import { InjectionToken } from '@angular/core'

export interface AuthEnvironmentModel {
  appName: 'ils-editor' | 'ils-manager' | 'translation-system' | 'ils-player'
  accessTokenKey: string
  profileKey: string
  useLocalStorage?: boolean
}

export const AUTH_CONFIG = new InjectionToken<AuthEnvironmentModel>('AuthEnvironmentModel')
